<div class="container-fluid p-0 dashboard-wrapper">
  <div class="row">
    <div class="col-md-12">
      <div class="w-100">
        <div class="row mb-2">
          <div class="col-3">
            <h3 class="page-title">New Case</h3>
          </div>
          <!-- <div class="col-2"></div> -->
          <div class="col-8 pl-0 d-flex justify-content-between align-items-center">
            <h3 class="fw-400"><i class="fa fa-angle-left mr-1 cursor-pointer" (click)="activeStep = activeStep - 1" *ngIf="activeStep"></i> {{ caseSteps[activeStep].name }}</h3>
            <div>
              <!-- <button
                type="button"
                class="btn spear-button-background btn-md text-white mr-4"
                *ngIf="activeStep == caseSteps.length - 1"
              >
                Submit
              </button> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
              <div class=" mr-4">
                <div class="row">
                  <div class="col-3">
                    <ng-container *ngFor="let step of caseSteps">
                      <div class="my-3" *ngIf="step.key != 'preview'">
                        <i [ngClass]="{
                          'fa': true,
                          'fa-check-circle-o': step.checked,
                          'fa-circle-thin': !step.checked
                        }"></i>
                        <label class="ml-2" for="{{ step.key }}">{{ step.name }}</label>

                        <ng-container *ngIf="caseData$ | async as caseData">
                          <ng-container *ngIf="step.key == 'subject_details' && caseData?.subject_detail?.length">
                            <ng-container *ngFor="let subject of caseData?.subject_detail; let j = index">
                              <div class="ml-4">
                                <i class="fa fa-level-up rotate-90"></i>
                                <label class="ml-2 cursor-pointer" (click)="prefillSubject(subject, j)">{{ subject.type | humanizeText }}</label>
                              </div>
                            </ng-container>
                          </ng-container>

                          <ng-container *ngIf="step.key == 'location_details' && caseData?.location_detail?.length">
                            <ng-container *ngFor="let location of caseData?.location_detail; let i = index">
                              <div class="ml-4">
                                <i class="fa fa-level-up rotate-90"></i>
                                <label class="ml-2 cursor-pointer" (click)="prefillLocation(location, i)">Location {{ i+1 }}</label>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </div>

                    </ng-container>
                  </div>
                  <div class="col-8" [ngClass]="{'border-grey search-spear-background p-4': activeStep != 4}">
                    <app-client-information *ngIf="activeStep == 0"
                      (formSubmitted)="handleStepFormSubmit('client_information',1)"></app-client-information>
                    <app-location-detail *ngIf="activeStep == 1" [location]="activeLocation" [editLocationIndex]="editLocationIndex"
                      (formSubmitted)="handleStepFormSubmit('location_details',2)">
                    </app-location-detail>
                    <app-subject-detail *ngIf="activeStep == 2"
                      (formSubmitted)="handleStepFormSubmit('subject_details',3)" [subject]="activeSubject" [editSubjectIndex]="editSubjectIndex"></app-subject-detail>
                    <!-- <app-case-detail *ngIf="activeStep == 3" (formSubmitted)="handleStepFormSubmit('case_details',4)"></app-case-detail> -->
                    <app-case-preview *ngIf="activeStep == 3" ></app-case-preview>
                  </div>
                </div>
              </div>
          </div>

        </div>
      </div>
    </div>
  </div>